import React from 'react';


class TBody extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        const { columns, rows, tableId, rowsSelected, keyRow,onDoubleClick } = this.props;
        const dataColumns = columns;
        const dataRows = rows;
        const _self = this;
        let _tableBody = "";

        _tableBody = dataRows.map(function (row, index) {
            let keyValue = row[keyRow];
            let findedRow = rowsSelected != undefined ? rowsSelected.find(item => { return item[keyRow] == keyValue }) : undefined;

            return (
                <tr key={index}
                    onClick={() => { _self.props.onSelectedRow != undefined ? _self.props.onSelectedRow(row, tableId) : () => { } }} className={findedRow != undefined ? 'selected' : ''}
                    onDoubleClick={onDoubleClick}>

                    {dataColumns.map(function (column, indexColumn) {
            
                        return <th scope="row"
                            style={column.style == undefined ? {} : column.style}
                            className={column.class == undefined ? '' : column.class}
                            key={index + indexColumn} 
                            hidden= {column.hidden == undefined ? false : column.hidden }>
                       
                                {column.isImage == undefined ? row[column.field] : <img src={row[column.field]}
                                    style={column.style == undefined ? {} : column.style} />}
                               
                        </th>;
                    })}
                </tr>);

        });


        return (
            <tbody>
                {_tableBody}
            </tbody>
        )
    }
};

export default TBody; 